module.exports = __webpack_public_path__ + "img/majiang.66c21709.png";